/* ss-designs.js — GENERATED by Label Farm's Seal Studio (/seal-studio).
 * Do not hand-edit: the next publish regenerates this file completely
 * and overwrites it. Retired designs stay here with retired:true so
 * past orders keep rendering; the theme's sellable() filter hides
 * them from sale. */
window.SS_DESIGNS = [
  {
    "key": "p_ledger_6f87",
    "base": "f_full",
    "name": "Ledger",
    "desc": "Black label blocks on bare foil — your name, a boxed logo and the serial in solid ink.",
    "bg": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_ledger_6f87.webp?v=1792614069",
    "category": "artwork",
    "retired": false,
    "bg_pf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_ledger_6f87-pf.webp?v=1792614070",
    "bg_ls": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_ledger_6f87-ls.webp?v=1792614071",
    "bg_lf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_ledger_6f87-lf.webp?v=1792614072",
    "defaults": {
      "brand": "",
      "color": "#111111"
    }
  },
  {
    "key": "p_orbit_92ec",
    "base": "f_full",
    "name": "Orbit",
    "desc": "",
    "bg": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_orbit_92ec.webp?v=1788129799",
    "category": "artwork",
    "retired": false,
    "bg_pf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_orbit_92ec-pf.webp?v=1788129801",
    "bg_ls": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_orbit_92ec-ls.webp?v=1788129802",
    "bg_lf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_orbit_92ec-lf.webp?v=1788129804",
    "defaults": {
      "brand": "",
      "color": "#5b21b6"
    }
  },
  {
    "key": "p_nova_b324",
    "base": "f_full",
    "name": "Nova",
    "desc": "",
    "bg": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_nova_b324.webp?v=1788129791",
    "category": "artwork",
    "retired": false,
    "bg_pf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_nova_b324-pf.webp?v=1788129792",
    "bg_ls": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_nova_b324-ls.webp?v=1788129794",
    "bg_lf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_nova_b324-lf.webp?v=1788129795",
    "defaults": {
      "brand": "",
      "color": "#5b21b6"
    }
  },
  {
    "key": "p_fire_phoenix_a157",
    "base": "f_full",
    "name": "Heat",
    "desc": "",
    "bg": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_fire_phoenix_a157.webp?v=1785722841",
    "category": "artwork",
    "retired": false,
    "bg_pf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_fire_phoenix_a157-pf.webp?v=1785722843",
    "bg_ls": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_fire_phoenix_a157-ls.webp?v=1785722845",
    "bg_lf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_fire_phoenix_a157-lf.webp?v=1785722846",
    "defaults": {
      "brand": "",
      "color": "#a16207"
    }
  },
  {
    "key": "p_prismatic_7264",
    "base": "f_full",
    "name": "Mint",
    "desc": "",
    "bg": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_prismatic_7264.webp?v=1785722442",
    "category": "artwork",
    "retired": false,
    "bg_pf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_prismatic_7264-pf.webp?v=1785722444",
    "bg_ls": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_prismatic_7264-ls.webp?v=1785722446",
    "bg_lf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_prismatic_7264-lf.webp?v=1785722447",
    "defaults": {
      "brand": "",
      "color": "#5b21b6"
    }
  },
  {
    "key": "p_garden_be60",
    "base": "f_full",
    "name": "Fabled",
    "desc": "",
    "bg": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_garden_be60.webp?v=1785722290",
    "category": "artwork",
    "retired": false,
    "bg_pf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_garden_be60-pf.webp?v=1785722292",
    "bg_ls": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_garden_be60-ls.webp?v=1785722294",
    "bg_lf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_garden_be60-lf.webp?v=1785722295",
    "defaults": {
      "brand": "",
      "color": "#ddef4d"
    }
  },
  {
    "key": "p_holo_storm_6dc5",
    "base": "f_full",
    "name": "Cosmic",
    "desc": "",
    "bg": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_holo_storm_6dc5.webp?v=1785720077",
    "category": "artwork",
    "retired": false,
    "bg_pf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_holo_storm_6dc5-pf.webp?v=1785720079",
    "bg_ls": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_holo_storm_6dc5-ls.webp?v=1785720080",
    "bg_lf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_holo_storm_6dc5-lf.webp?v=1785720081",
    "defaults": {
      "brand": "",
      "color": "#5b21b6"
    }
  },
  {
    "key": "p_moonlit_eclipse_0336",
    "base": "f_full",
    "name": "Omen",
    "desc": "",
    "bg": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_moonlit_eclipse_0336.webp?v=1785719801",
    "category": "artwork",
    "retired": false,
    "bg_pf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_moonlit_eclipse_0336-pf.webp?v=1785720825",
    "bg_ls": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_moonlit_eclipse_0336-ls.webp?v=1785720826",
    "bg_lf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_moonlit_eclipse_0336-lf.webp?v=1785720827",
    "defaults": {
      "brand": "",
      "color": "#ffffff"
    }
  },
  {
    "key": "p_lightning_b52d",
    "base": "f_full",
    "name": "Surge",
    "desc": "",
    "bg": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_lightning_b52d.webp?v=1785719653",
    "category": "artwork",
    "retired": false,
    "bg_pf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_lightning_b52d-pf.webp?v=1785720832",
    "bg_ls": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_lightning_b52d-ls.webp?v=1785720834",
    "bg_lf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_lightning_b52d-lf.webp?v=1785720835",
    "defaults": {
      "brand": "",
      "color": "#ffdd00"
    }
  },
  {
    "key": "p_one_a381",
    "base": "f_full",
    "name": "Alpha",
    "desc": "",
    "bg": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_one_a381.webp?v=1785717815",
    "category": "artwork",
    "retired": false,
    "bg_pf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_one_a381-pf.webp?v=1785720840",
    "bg_ls": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_one_a381-ls.webp?v=1785720841",
    "bg_lf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_one_a381-lf.webp?v=1785720842",
    "defaults": {
      "brand": "",
      "color": "#5b21b6"
    }
  },
  {
    "key": "p_bubble_2ea2",
    "base": "f_full",
    "name": "Chase",
    "desc": "",
    "bg": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_bubble_2ea2.webp?v=1785720846",
    "category": "artwork",
    "retired": false,
    "bg_pf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_bubble_2ea2-pf.webp?v=1785720848",
    "bg_ls": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_bubble_2ea2-ls.webp?v=1785720849",
    "bg_lf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_bubble_2ea2-lf.webp?v=1785720851",
    "defaults": {
      "brand": "",
      "color": "#5b21b6"
    }
  },
  {
    "key": "p_aqua_storm_211f",
    "base": "f_full",
    "name": "Riptide",
    "desc": "",
    "bg": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_aqua_storm_211f.webp?v=1785720854",
    "category": "artwork",
    "retired": false,
    "bg_pf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_aqua_storm_211f-pf.webp?v=1785720856",
    "bg_ls": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_aqua_storm_211f-ls.webp?v=1785720857",
    "bg_lf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_aqua_storm_211f-lf.webp?v=1785720859",
    "defaults": {
      "brand": "",
      "color": "#374151"
    }
  },
  {
    "key": "p_inferno_93b8",
    "base": "f_full",
    "name": "Burn",
    "desc": "",
    "bg": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_inferno_93b8.webp?v=1785722080",
    "category": "artwork",
    "retired": false,
    "bg_pf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_inferno_93b8-pf.webp?v=1785722082",
    "bg_ls": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_inferno_93b8-ls.webp?v=1785722084",
    "bg_lf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_inferno_93b8-lf.webp?v=1785722085",
    "defaults": {
      "brand": "",
      "color": "#ffffff"
    }
  },
  {
    "key": "p_vortex_0c99",
    "base": "f_full",
    "name": "Vortex",
    "desc": "",
    "bg": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_vortex_0c99.webp?v=1787037996",
    "category": "artwork",
    "retired": false,
    "bg_pf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_vortex_0c99-pf.webp?v=1787037998",
    "bg_ls": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_vortex_0c99-ls.webp?v=1787037999",
    "bg_lf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_vortex_0c99-lf.webp?v=1787038000"
  },
  {
    "key": "p_ember_d7b1",
    "base": "f_full",
    "name": "Ember",
    "desc": "",
    "bg": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_ember_d7b1.webp?v=1787038005",
    "category": "artwork",
    "retired": false,
    "bg_pf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_ember_d7b1-pf.webp?v=1787038006",
    "bg_ls": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_ember_d7b1-ls.webp?v=1787038007",
    "bg_lf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_ember_d7b1-lf.webp?v=1787038009"
  },
  {
    "key": "p_frost_9372",
    "base": "f_full",
    "name": "Frost",
    "desc": "",
    "bg": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_frost_9372.webp?v=1787038014",
    "category": "artwork",
    "retired": false,
    "bg_pf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_frost_9372-pf.webp?v=1787038015",
    "bg_ls": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_frost_9372-ls.webp?v=1787038017",
    "bg_lf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_frost_9372-lf.webp?v=1787038018"
  },
  {
    "key": "p_venom_ffe2",
    "base": "f_full",
    "name": "Venom",
    "desc": "",
    "bg": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_venom_ffe2.webp?v=1787038023",
    "category": "artwork",
    "retired": false,
    "bg_pf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_venom_ffe2-pf.webp?v=1787038024",
    "bg_ls": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_venom_ffe2-ls.webp?v=1787038026",
    "bg_lf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_venom_ffe2-lf.webp?v=1787038027"
  },
  {
    "key": "p_static_34c7",
    "base": "f_full",
    "name": "Static",
    "desc": "",
    "bg": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_static_34c7.webp?v=1787038032",
    "category": "artwork",
    "retired": false,
    "bg_pf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_static_34c7-pf.webp?v=1787038033",
    "bg_ls": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_static_34c7-ls.webp?v=1787038034",
    "bg_lf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_static_34c7-lf.webp?v=1787038035"
  },
  {
    "key": "p_halo_09f5",
    "base": "f_full",
    "name": "Halo",
    "desc": "",
    "bg": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_halo_09f5.webp?v=1787038041",
    "category": "artwork",
    "retired": false,
    "bg_pf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_halo_09f5-pf.webp?v=1787038042",
    "bg_ls": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_halo_09f5-ls.webp?v=1787038043",
    "bg_lf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_halo_09f5-lf.webp?v=1787038044"
  },
  {
    "key": "p_pearl_450c",
    "base": "f_full",
    "name": "Pearl",
    "desc": "",
    "bg": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_pearl_450c.webp?v=1787038477",
    "category": "artwork",
    "retired": false,
    "bg_pf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_pearl_450c-pf.webp?v=1787038478",
    "bg_ls": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_pearl_450c-ls.webp?v=1787038480",
    "bg_lf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_pearl_450c-lf.webp?v=1787038481"
  },
  {
    "key": "p_divine_b392",
    "base": "f_full",
    "name": "Divine",
    "desc": "",
    "bg": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_divine_b392.webp?v=1787038486",
    "category": "artwork",
    "retired": false,
    "bg_pf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_divine_b392-pf.webp?v=1787038487",
    "bg_ls": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_divine_b392-ls.webp?v=1787038489",
    "bg_lf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_divine_b392-lf.webp?v=1787038490"
  },
  {
    "key": "p_sakura_a5f6",
    "base": "f_full",
    "name": "Sakura",
    "desc": "",
    "bg": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_sakura_a5f6.webp?v=1787038495",
    "category": "artwork",
    "retired": false,
    "bg_pf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_sakura_a5f6-pf.webp?v=1787038497",
    "bg_ls": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_sakura_a5f6-ls.webp?v=1787038498",
    "bg_lf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_sakura_a5f6-lf.webp?v=1787038499"
  },
  {
    "key": "p_mirage_c95d",
    "base": "f_full",
    "name": "Mirage",
    "desc": "",
    "bg": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_mirage_c95d.webp?v=1787038504",
    "category": "artwork",
    "retired": false,
    "bg_pf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_mirage_c95d-pf.webp?v=1787038505",
    "bg_ls": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_mirage_c95d-ls.webp?v=1787038507",
    "bg_lf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_mirage_c95d-lf.webp?v=1787038508"
  },
  {
    "key": "p_flux_12e6",
    "base": "f_full",
    "name": "Flux",
    "desc": "",
    "bg": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_flux_12e6.webp?v=1787332810",
    "category": "artwork",
    "retired": false,
    "bg_pf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_flux_12e6-pf.webp?v=1787332811",
    "bg_ls": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_flux_12e6-ls.webp?v=1787332813",
    "bg_lf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_flux_12e6-lf.webp?v=1787332814"
  },
  {
    "key": "p_onyx_4969",
    "base": "f_full",
    "name": "Onyx",
    "desc": "",
    "bg": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_onyx_4969.webp?v=1787332819",
    "category": "artwork",
    "retired": false,
    "bg_pf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_onyx_4969-pf.webp?v=1787332821",
    "bg_ls": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_onyx_4969-ls.webp?v=1787332822",
    "bg_lf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_onyx_4969-lf.webp?v=1787332824"
  },
  {
    "key": "p_rift_0596",
    "base": "f_full",
    "name": "Rift",
    "desc": "",
    "bg": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_rift_0596.webp?v=1787332828",
    "category": "artwork",
    "retired": false,
    "bg_pf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_rift_0596-pf.webp?v=1787332830",
    "bg_ls": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_rift_0596-ls.webp?v=1787332831",
    "bg_lf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_rift_0596-lf.webp?v=1787332832"
  },
  {
    "key": "p_circuit_4efe",
    "base": "f_full",
    "name": "Circuit",
    "desc": "",
    "bg": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_circuit_4efe.webp?v=1787332836",
    "category": "artwork",
    "retired": false,
    "bg_pf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_circuit_4efe-pf.webp?v=1787332837",
    "bg_ls": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_circuit_4efe-ls.webp?v=1787332839",
    "bg_lf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_circuit_4efe-lf.webp?v=1787332840"
  },
  {
    "key": "p_kaleido_d392",
    "base": "f_full",
    "name": "Kaleido",
    "desc": "",
    "bg": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_kaleido_d392.webp?v=1787332845",
    "category": "artwork",
    "retired": false,
    "bg_pf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_kaleido_d392-pf.webp?v=1787332846",
    "bg_ls": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_kaleido_d392-ls.webp?v=1787332848",
    "bg_lf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_kaleido_d392-lf.webp?v=1787332849"
  },
  {
    "key": "p_bloom_0bc7",
    "base": "f_full",
    "name": "Bloom",
    "desc": "",
    "bg": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_bloom_0bc7.webp?v=1787332854",
    "category": "artwork",
    "retired": false,
    "bg_pf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_bloom_0bc7-pf.webp?v=1787332855",
    "bg_ls": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_bloom_0bc7-ls.webp?v=1787332857",
    "bg_lf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_bloom_0bc7-lf.webp?v=1787332858"
  },
  {
    "key": "p_gridiron_1bf9",
    "base": "f_full",
    "name": "Gridiron",
    "desc": "Sports series — Gridiron",
    "bg": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_gridiron_1bf9.webp?v=1786380236",
    "category": "sports",
    "retired": true,
    "bg_pf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_gridiron_1bf9-pf.webp?v=1786380238",
    "bg_ls": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_gridiron_1bf9-ls.webp?v=1786380239",
    "bg_lf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_gridiron_1bf9-lf.webp?v=1786380240",
    "defaults": {
      "brand": "",
      "color": "#166534"
    }
  },
  {
    "key": "p_hardwood_prime_bca6",
    "base": "f_full",
    "name": "Hardwood Prime",
    "desc": "Sports series — Hardwood Prime",
    "bg": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_hardwood_prime_bca6.webp?v=1786380229",
    "category": "sports",
    "retired": true,
    "bg_pf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_hardwood_prime_bca6-pf.webp?v=1786380230",
    "bg_ls": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_hardwood_prime_bca6-ls.webp?v=1786380232",
    "bg_lf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_hardwood_prime_bca6-lf.webp?v=1786380233",
    "defaults": {
      "brand": "",
      "color": "#b45309"
    }
  },
  {
    "key": "p_diamond_dust_4100",
    "base": "f_full",
    "name": "Diamond Dust",
    "desc": "Sports series — Diamond Dust",
    "bg": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_diamond_dust_4100.webp?v=1786380223",
    "category": "sports",
    "retired": true,
    "bg_pf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_diamond_dust_4100-pf.webp?v=1786380224",
    "bg_ls": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_diamond_dust_4100-ls.webp?v=1786380225",
    "bg_lf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_diamond_dust_4100-lf.webp?v=1786380226",
    "defaults": {
      "brand": "",
      "color": "#15803d"
    }
  },
  {
    "key": "p_stadium_lights_a65e",
    "base": "f_full",
    "name": "Stadium Lights",
    "desc": "Sports series — Stadium Lights",
    "bg": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_stadium_lights_a65e.webp?v=1786380216",
    "category": "sports",
    "retired": true,
    "bg_pf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_stadium_lights_a65e-pf.webp?v=1786380217",
    "bg_ls": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_stadium_lights_a65e-ls.webp?v=1786380218",
    "bg_lf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_stadium_lights_a65e-lf.webp?v=1786380220",
    "defaults": {
      "brand": "",
      "color": "#1d4ed8"
    }
  },
  {
    "key": "p_pagoda_garden_5996",
    "base": "f_full",
    "name": "Pagoda Garden",
    "desc": "",
    "bg": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_pagoda_garden_5996.webp?v=1785722990",
    "category": "artwork",
    "retired": true,
    "bg_pf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_pagoda_garden_5996-pf.webp?v=1785722992",
    "bg_ls": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_pagoda_garden_5996-ls.webp?v=1785722993",
    "bg_lf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_pagoda_garden_5996-lf.webp?v=1785722995",
    "defaults": {
      "brand": "",
      "color": "#952376"
    }
  },
  {
    "key": "p_psychic_bloom_d6ba",
    "base": "f_full",
    "name": "Psychic Bloom",
    "desc": "",
    "bg": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_psychic_bloom_d6ba.webp?v=1785722538",
    "category": "artwork",
    "retired": true,
    "bg_pf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_psychic_bloom_d6ba-pf.webp?v=1785722540",
    "bg_ls": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_psychic_bloom_d6ba-ls.webp?v=1785722541",
    "bg_lf": "https://cdn.shopify.com/s/files/1/0721/3652/3850/t/1/assets/seal-bg-p_psychic_bloom_d6ba-lf.webp?v=1785722542",
    "defaults": {
      "brand": "",
      "color": "#5b21b6"
    }
  }
];
